import React, {ChangeEvent, FC, FormEvent, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {OptionType} from "../../../../helpers/utils/StyleUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import {createOptionListForSelectTag} from "../../../../helpers/utils/Utils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {Routes as AppRoutes} from "../../../../routes";
import {useGetAllStatesQuery} from "../../states/statesApi";
import {useGetAllCountyByStateAbbrQuery, useGetCountyByIdQuery} from "../../counties/countiesApi";
import {skipToken} from "@reduxjs/toolkit/query";
import {useCreateSubDivisionMutation} from "../subDivisionApi";
import {useLocation} from "react-router";


const CreateSubdivision: FC = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Subdivisions", url: AppRoutes.Subdivision.path},
        {content: "Add Subdivision", url: ""},
    ]);

    const navigate = useNavigate();
    const location = useLocation();

    const [subdivisionData, setSubdivisionData] = useState<any>({state: {label: "Texas", value: "TX"}});
    ;
    const [createApi, createApiResponse] = useCreateSubDivisionMutation();
    const statesApiResult = useGetAllStatesQuery("");
    const countyByIdApiResult = useGetCountyByIdQuery(location.search ? new URLSearchParams(window.location.search).get("county") : skipToken);
    const countiesApiResult = useGetAllCountyByStateAbbrQuery(subdivisionData?.state?.value ?? skipToken);

    useEffect(() => {
        let obj = countyByIdApiResult?.data;
        if (location.search !== "" && location.search !== undefined && obj) {

            setSubdivisionData({
                ...subdivisionData,
                county: {
                    label: obj?.countyName,
                    value: obj?.id,
                },
                state: {
                    label: obj?.state.stateName,
                    value: obj?.state.stateAbbreviation,
                }
            })

        }
    }, [countyByIdApiResult]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const obj: any = {
            subdivisionKey: {
                name: subdivisionData?.name,
                unit: subdivisionData?.unit,
                phase: subdivisionData?.phase,
                section: subdivisionData?.section
            },
            stateAbbr: subdivisionData?.state?.value,
            countyId: subdivisionData?.county?.value,
            expectedTaxYear: null,
            subdivisionCode: subdivisionData?.code,
            city: subdivisionData.city,
            aliases: [],
        }

        await handleRTKQuery(
            async () => {
                return await createApi(obj).unwrap();
            },
            (response: any) => {
                if (response?.success || response?.data?.success) {
                    setSubdivisionData({});
                    navigate(AppRoutes.Subdivision.path);
                }
            }
        );
    }
    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const {name, value} = "target" in e ? e.target : e;
        setSubdivisionData({
            ...subdivisionData,
            [name]: value,
        })
    }


    useEffect(() => {

        let val = subdivisionData?.customerLevel?.value;
        if (val === "TENANT") {
            setSubdivisionData({
                ...subdivisionData,
                tenantId: null
            })
        }

    }, [subdivisionData?.customerLevel]);


    return (
        <>

            <div className="adduser_container px-4 py-2">

                <Breadcrumb crumbs={crumbs}/>
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-5">Add
                            Subdivision
                        </h3>

                        <Form onSubmit={handleSubmit} fields={<>

                            <div className="grid grid-cols-12 adduser_Wrapper">
                                <InputField
                                    name={"name"}
                                    label="Name"
                                    onChange={handleOnChange}
                                    value={subdivisionData?.name || ""}
                                    type="text"
                                    placeholder="Enter Name..."
                                    required={true}
                                />

                                <SelectField
                                    placeholder='Select State...'
                                    value={subdivisionData?.state}
                                    options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "stateAbbreviation")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({name: "state", value: selectedOption})
                                    }}
                                    label={"State"}
                                    required={true}
                                />
                                <SelectField
                                    placeholder='Select County...'
                                    value={subdivisionData?.county}
                                    options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({name: "county", value: selectedOption})
                                    }}
                                    label={"County"}
                                    required={true}

                                />

                                <InputField
                                    name={"city"}
                                    label="City"
                                    onChange={handleOnChange}
                                    value={subdivisionData?.city || ""}
                                    type="text"
                                    placeholder="Enter City..."
                                />
                                <InputField
                                    name={"code"}
                                    label="Subdivision Code"
                                    onChange={handleOnChange}
                                    value={subdivisionData?.code || ""}
                                    type="text"
                                    placeholder="Enter Subdivision Code..."
                                />


                                <div className="col-span-12 grid grid-cols-12 gap-3">
                                    <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        <label className="min-w-[100px]">Unit / Phase / Section</label>
                                    </div>
                                    <div className="relative col-span-9 flex items-center gap-3">
                                        <div className="w-full">
                                            <InputField
                                                hideLabel
                                                placeholder="Enter Unit..."
                                                type="text"
                                                name={"unit"}
                                                value={subdivisionData?.unit || ""}
                                                onChange={handleOnChange}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                label="Phase"
                                                placeholder="Enter Phase..."
                                                type="text"
                                                name={"phase"}
                                                value={subdivisionData?.phase || ""}
                                                onChange={handleOnChange}

                                                hideLabel={true}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <InputField
                                                label="Section"
                                                placeholder="Enter Section..."
                                                type="text"
                                                name={"section"}
                                                value={subdivisionData?.section || ""}
                                                onChange={handleOnChange}

                                                hideLabel={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                </div>
                                <div className="relative col-span-9">
                                    <div className={"mt-4 flex"}>
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => navigate(AppRoutes.Subdivision.path),
                                                        type: "close",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: (createApiResponse.isLoading),
                                                    },
                                                    buttonType: "button"
                                                }
                                            ]}
                                            align="center"
                                            gap={2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>}/>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CreateSubdivision;